import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../Header';
import Footer from '../Footer';

const Layout = ({ children, title = "Default Title", description = "Default description of the page" }) => {
	return (
		<div>
			<Helmet>
				<title>{title}</title>
				<meta name="description" content={description} />
			</Helmet>
			<Header />
			<div className="content-container">
				{children}
			</div>
			<Footer />
		</div>
	);
};

export default Layout;
